import shopify_buy_button from "../shopify_buy_button"
import {Controller} from "@hotwired/stimulus"
import {useMutation} from "stimulus-use"
import load_script from "../load_script"

let initialized = false
const url =
  "https://sdks.shopifycdn.com/buy-button/latest/buy-button-storefront.min.js"

class ShopifyBuyButtonController extends Controller {
  static values = {
    variant: String
  }

  connect() {
    this.success_page = this.element.closest(".box.payment-complete")
    useMutation(this, {
      element: this.success_page,
      attributes: true,
      attributeFilter: ["class"]
    })
    load_script(url).then(() => {
      if (document.body.classList.contains("dashboard")) {
        this.init()
      }
    })
  }

  mutate(mutations) {
    mutations.forEach(mutation => {
      if (mutation.attributeName === "class") {
        if (!this.success_page?.classList?.contains("hide-it")) {
          this.init()
        }
      }
    })
  }

  init() {
    if (initialized) return

    initialized = true
    shopify_buy_button(this.element, this.variantValue)
  }
}

export default ShopifyBuyButtonController
